// Default event images for random selection when no image is provided
// Modern, vibrant line dancing and country western themed images
export const DEFAULT_EVENT_IMAGES = [
  // Couple dancing together - country western
  'https://images.unsplash.com/photo-1707192325496-e38a59d54d9e?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800',
  // Lively outdoor night party with people dancing under string lights
  'https://images.pexels.com/photos/30505259/pexels-photo-30505259.jpeg?auto=compress&cs=tinysrgb&w=800',
  // Silhouette of energetic crowd enjoying a live concert
  'https://images.pexels.com/photos/11963121/pexels-photo-11963121.png?auto=compress&cs=tinysrgb&w=800',
  // Couple dancing together at event
  'https://images.unsplash.com/photo-1707192325157-58ebd075b80d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800',
  // Dancing in a tent atmosphere
  'https://images.unsplash.com/photo-1592072366886-1c699c5ff4a1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800',
  // People dancing in a room
  'https://images.unsplash.com/photo-1707194899538-d2a7ac1089bc?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800',
  // Group of people on stage
  'https://images.unsplash.com/photo-1740572569779-4927d8c02f81?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800',
  // Street dance group
  'https://images.unsplash.com/photo-1684259498663-eedf93530003?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800',
  // Colorful western dress walking on street
  'https://images.unsplash.com/photo-1603165145271-1d928986d856?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800',
  // Romantic cowboy boots close-up
  'https://images.pexels.com/photos/35240168/pexels-photo-35240168.jpeg?auto=compress&cs=tinysrgb&w=800',
  // Silhouette of couple dancing at sunset
  'https://images.unsplash.com/photo-1581719718450-db70849cbd46?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800',
  // Traditional colorful dance performance
  'https://images.pexels.com/photos/31206810/pexels-photo-31206810.jpeg?auto=compress&cs=tinysrgb&w=800'
];

// Cache for custom images loaded from API
let customImagesCache = null;
let customImagesFetched = false;

// Fetch custom images from API (call once on app load)
export const fetchCustomImages = async () => {
  if (customImagesFetched) return customImagesCache;
  
  try {
    const { API_URL } = await import('./api');
    const res = await fetch(`${API_URL}/api/site-images`);
    if (res.ok) {
      const data = await res.json();
      if (data.images && data.images.length > 0) {
        customImagesCache = data.images;
      }
    }
  } catch (error) {
    console.error('Failed to fetch custom images:', error);
  }
  customImagesFetched = true;
  return customImagesCache;
};

// Get all available images (custom + defaults)
export const getAllImages = () => {
  if (customImagesCache && customImagesCache.length > 0) {
    return [...customImagesCache, ...DEFAULT_EVENT_IMAGES];
  }
  return DEFAULT_EVENT_IMAGES;
};

// Get a consistent random image based on event ID (so same event always shows same image)
export const getEventImage = (eventId, providedImage) => {
  if (providedImage) return providedImage;
  
  // Use all available images (custom + defaults)
  const images = getAllImages();
  
  // Use event ID to generate consistent index
  let hash = 0;
  const id = eventId || 'default';
  for (let i = 0; i < id.length; i++) {
    hash = ((hash << 5) - hash) + id.charCodeAt(i);
    hash = hash & hash; // Convert to 32bit integer
  }
  
  const index = Math.abs(hash) % images.length;
  return images[index];
};
